module.exports = __webpack_public_path__ + "static/media/icon-pill-pickleball.296f27ce.svg";